import React from "react";
import Box from "@mui/material/Box";
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Button from '@mui/material/Button';
import {Grid, Typography} from "@mui/material";
import CardMedia from '@mui/material/CardMedia';
import {Link} from "react-router-dom";

const Event = () => {
    return (
        <Box>
            <Grid container spacing={{md: 4}} columns={{xs: 1, sm: 1, md: 3, lg: 3, xl: 3}}>
                <Grid item xs={1} sm={1} md={2} lg={2} xl={2}>
                    <Card sx={{marginTop: 4}}>
                        <CardContent>
                            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                                NIEDZIELA, CZERWIEC 11, 2023 9:30 – 19:00
                            </Typography>
                            <Typography variant="h5" component="div">
                                Tolaria Online - March of the Machine
                            </Typography>
                            <Typography variant="body1" sx={{marginTop: 1}}>Tolaria Online jest wydarzeniem mającym na
                                celu wyróżnienie polskich graczy Limited w cyfrowych wersjach gry Magic: the
                                Gathering.<br/>
                                Najlepsi gracze na platformach MTG Arena oraz MTG Online spotkają we wspólnym turnieju
                                współzawodnicząc o tytuł Najlepszego Polskiego Gracza Limited w bieżącym formacie. Tym
                                razem polem zmagań będzie draft March of the Machine!</Typography>
                            <CardMedia
                                sx={{height: 480, marginTop: 2}}
                                image="https://scontent.fktw5-1.fna.fbcdn.net/v/t39.30808-6/346291129_1305786523626830_5776734699533680588_n.jpg?stp=cp6_dst-jpg_s960x960&_nc_cat=106&ccb=1-7&_nc_sid=340051&_nc_ohc=3IfC6ncHXr8AX_rshWk&_nc_ht=scontent.fktw5-1.fna&oh=00_AfCz2IZCGtF5I4cBXSdQsqZAeUj05MnJjAoHyU0vc5iXTw&oe=64777D31"
                                title="green iguana"
                            />
                            <Typography variant="body1" sx={{marginTop: 2}}>Trochę historii:</Typography>
                            <Typography variant="body2" sx={{marginTop: 1}}>Nasze wydarzenie odbyło swą pierwszą edycję
                                27 grudnia 2020. Jego roboczą nazwą było "The Limited of Poland". Była to jednak forma
                                ograniczona do drafta 8 wybitnych polskich graczy zaproszonych do udziału przez
                                organizatora. W turnieju brały udział takie osobistości jak: Grzegorz "Urlich Kowalski"
                                Radosław "Ishan" Kaczmarczyk, Maciej "Duo" Janik, Paweł Bujanowicz, Michał Surma, Daniel
                                "Sołtys" Sołtysik oraz Olaf Susicki. Wydarznie było streamowane na kilku kanałach
                                jednocześnie. Wygrał Jakub Janeczek: <Link
                                    to={`https://www.youtube.com/watch?v=2qQgQtVhNOI&amp;fbclid=IwAR0h39zJ5wZR459hUAydMfO5Tpu4-9BrT1Vgz2J_40NcCBb-ltfFtsIBH8M`}>https://www.youtube.com/watch?v=2qQgQtVhNOI&amp;fbclid=IwAR0h39zJ5wZR459hUAydMfO5Tpu4-9BrT1Vgz2J_40NcCBb-ltfFtsIBH8M</Link></Typography>
                            <Typography variant="body2" sx={{marginTop: 1}}>Następne wydarzenie o właściwej już nazwie:
                                Tolaria Online - Kaldheim odbyło się w formie 2-dniowego turnieju w którym wzięło udział
                                34 zakwalifikowanych graczy. Dzień pierwszy odbywał się formacie sealed deck a top 8
                                grało draft dnia drugiego. Zwycięzcą tej edycji został Ivan Milenin. <Link
                                    to={`https://www.facebook.com/watch/live/?ref=watch_permalink&v=254168313047361`}>https://www.facebook.com/watch/live/?ref=watch_permalink&v=254168313047361</Link><br/>
                                Na podsumowanie sezonu Strixhaven oraz AFR mieliśm​y jednodniowy turniej na 24 i graczy
                                od początku do końca przeprowadzony w drafcie. Wygranym formatu STX był Michał Surma a
                                AFR Tomasz Szewców​​! Tolarię Double Innistrad ORAZ Kamigawę wygrał Piotr Widuch! Ojcem
                                Chrzestnym Capenny okazał się Dominik Konieczny aka Świstak. W Dominarii United
                                konsekwentnie zwycięstwo wypracował stały bywalec Tolarii - Oleksii Akinfiiev!<br/>
                                Bratobójczą Wojnę wygrał stosunkowo świeży zawodnik - Janusz Tarczykowski!<br/>
                                Phyrexia była powrotem Ivana Milenina na szczyt!</Typography>

                            <Typography variant="body1" sx={{marginTop: 2}}>Zasady turnieju:</Typography>
                            <Typography variant="body2" sx={{marginTop: 1}}>Termin: 11 czerwca 2023 (niedziela)<br/>
                                Godzina: 10:00<br/>
                                Start turnieju o 10:00. Struktura początkowych rund będzie uzależniona od ilości
                                zgłoszonych zakwalifikowanych graczy. Top 8 docelowo zagra o 15:00 w trybie single
                                elimination. Każde draftowanie będzie odbywać się na platformie mtgadraft.tk, a mecze
                                będą rozgrywane na platformie MTG Arena.<br/>
                                Wstęp: 50 zł / 100 zł (80 zł w przedsprzedaży)<br/>
                                Gdzie?<br/>
                                Discord Guildmage: <br/>
                                <Link
                                    to={`https://discord.gg/9rrQcTHrSG`}>https://discord.gg/9rrQcTHrSG</Link></Typography>
                            <Typography variant="body1" sx={{marginTop: 2}}>Jak się zakwalifikować?</Typography>
                            <Typography variant="body2" sx={{marginTop: 1}}>Aby zdobyć możliwość udziału w turnieju za
                                50 zł należy wysłać do organizatora potwierdzenie (np. w formie screenu ekranu) zdobycia
                                rangi Mythic Limited na MTG Arena w sezonie KWIECIEŃ lub MAJ lub potwierdzenie zdobycia
                                7 trophy na MTG Online w formacie Draft March of the Machine. Ostatecznym terminem
                                zdobycia i zgłoszenia tych osiągnieć jest 31 maja 2023.<br/>
                                Osoby, które nie zdobyły rangi Mythic Limited lub 7 trophy na MODO również mogą wziąć
                                udział w wydarzeniu. W takim wypadku wejściówka kosztuje 100 zł, a w przedsprzedaży (do
                                31 maja 2023) 80 zł.</Typography>

                            <Typography variant="body1" sx={{marginTop: 2}}>Gdzie kupić bilet?</Typography>
                            <Typography variant="body2" sx={{marginTop: 1}}>Mythic 50 zł (dla osób, które zdobyły
                                kwalifikację):
                                <Button size="small" component="a"
                                        href="https://app.easycart.pl/checkout/50766280/tolaria-online-march-of-the-machine"
                                        target="_blank">Kup Bilet</Button><br/>
                                Regular 100 zł (dla osób, które nie zdobyły kwalifikacji):
                                <Button size="small" component="a"
                                        href="https://app.easycart.pl/checkout/50766280/tolaria-online-march-of-the-machine"
                                        target="_blank">Kup Bilet</Button><br/>
                                Przedsprzedaż 80 zł (bez kwalifikacji, do 31 maja 2023):
                                <Button size="small" component="a"
                                        href="https://app.easycart.pl/checkout/50766280/tolaria-online-march-of-the-machine"
                                        target="_blank">Kup Bilet</Button><br/>
                                Ostateczny termin rejestracji i dokonywania wpłat to 7 czerwca.<br/>
                                W razie problemów z dokonaniem płatności prośba o kontakt z organizatorem.</Typography>

                            <Typography variant="body1" sx={{marginTop: 2}}>Nagrody:</Typography>
                            <Typography variant="body2" sx={{marginTop: 1}}>80% puli zostanie przeznaczone na nagrody, a
                                20% na pokrycie kosztów organizacji turnieju.
                                Dodatkowo zwycięzca dostanie kolekcjonerską playmatę Guildmage z Black Lotusem, a osoba,
                                która zajmie drugie miejsce dostanie koszulkę Guildmage.</Typography>

                            <Typography variant="body1" sx={{marginTop: 2}}>Kontakt:</Typography>
                            <Typography variant="body2" sx={{marginTop: 1}}>michal.j.pajek@gmail.com lub
                                info@guildmage.pl<br/>
                                Informacje na temat turnieju możecie śledzić na bieżąco także na grupie:
                                www.facebook.com/groups/392513811349630

                                <Typography variant="body1" sx={{marginTop: 2}}>Organizatorzy:</Typography>
                                <Typography variant="body2" sx={{marginTop: 1}}>Nostalgia Cube - promotor casualowych
                                    formatów limited<br/>
                                    Guildmage - polska strona Magica</Typography>
                                <Typography variant="body1" sx={{marginTop: 2}}>Patroni medialni:</Typography>
                                <Typography variant="body2" sx={{marginTop: 1}}></Typography>https://guildmage.pl<br/>
                                https://psychatog.pl</Typography>
                        </CardContent>
                    </Card>
                    <Box
                        component="img"
                        sx={{
                            maxWidth: {md: "100%"}, borderRadius: 5,
                        }}
                    />
                </Grid>
                <Grid item xs={1} sm={1} md={1} lg={1} xl={1}>
                    <Card sx={{marginTop: 4}}>
                        <CardContent>
                            <Typography sx={{fontSize: 14}} color="text.secondary" gutterBottom>
                                50 zł / 80 zł / 100 zł
                            </Typography>
                            <Typography variant="h5" component="div">
                                Kup Bilet
                            </Typography>
                            <Typography variant="body1" sx={{marginTop: 1}}>Mythic 50 zł</Typography>
                            <Typography variant="body2">(dla osób, które zdobyły kwalifikację)</Typography>
                            <Typography variant="body1" sx={{marginTop: 1}}>Regular 100 zł</Typography>
                            <Typography variant="body2">(dla osób, które nie zdobyły kwalifikacji)</Typography>
                            <Typography variant="body1" sx={{marginTop: 1}}>Przedsprzedaż 80 zł</Typography>
                            <Typography variant="body2">(bez kwalifikacji, do 31 maja 2023)</Typography></CardContent>
                        <CardActions>
                            <Button size="small" component="a"
                                    href="https://app.easycart.pl/checkout/50766280/tolaria-online-march-of-the-machine"
                                    target="_blank">Kup Bilet</Button>

                        </CardActions>
                    </Card>
                </Grid>
            </Grid>
            <Box height={48}/>
        </Box>
    )
}

export default Event;
